import React, { useState } from 'react';

const CORRECT_PASSWORD = 'Vapi2025!';

function LoginPage({ onLoginSuccess }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [incorrectPasswordAttempt, setIncorrectPasswordAttempt] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    if (!email.trim()) {
      setError('Please enter an email address');
      return;
    }

    if (!email.toLowerCase().endsWith('@vapi.ai')) {
      setError('This app is only available to Vapi employees. Please use your @vapi.ai email address.');
      setIncorrectPasswordAttempt(false);
      setPassword('');
      return;
    }

    if (!password) {
      setError('Please enter a password');
      return;
    }

    setIsLoading(true);

    // Simulate a small delay for better UX
    setTimeout(() => {
      if (password === CORRECT_PASSWORD) {
        onLoginSuccess(email);
      } else {
        setError('Invalid password. Please try again.');
        setIncorrectPasswordAttempt(true);
        setPassword('');
      }
      setIsLoading(false);
    }, 300);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-lg shadow-xl p-8">
          {/* Header */}
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-gray-800 mb-2">Revenue Forecast</h1>
            <p className="text-gray-600">FY26 Projection Dashboard</p>
          </div>

          {/* Access Request Message - Only shown on wrong password */}
          {incorrectPasswordAttempt && (
            <div className="mb-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
              <p className="text-sm text-blue-900 mb-2 font-medium">
                Welcome to the Vapi Revenue Forecast Dashboard
              </p>
              <p className="text-sm text-blue-800 mb-3">
                This dashboard provides secure access to FY26 revenue projections and forecast analytics. If you don't have access credentials, please request them from:
              </p>
              <p className="text-sm font-semibold text-blue-900">
                <a href="mailto:eva@vapi.ai" className="text-blue-600 hover:text-blue-700 underline">eva@vapi.ai</a>
              </p>
            </div>
          )}

          {/* Login Form */}
          <form onSubmit={handleSubmit} className="space-y-4">
            {/* Email Input */}
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                Email Address
              </label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                disabled={isLoading}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition disabled:bg-gray-100 disabled:cursor-not-allowed"
              />
            </div>

            {/* Password Input */}
            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-2">
                Password
              </label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
                disabled={isLoading}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition disabled:bg-gray-100 disabled:cursor-not-allowed"
              />
            </div>

            {/* Error Message */}
            {error && (
              <div className="p-3 bg-red-50 border border-red-200 rounded-lg">
                <p className="text-sm text-red-700">{error}</p>
              </div>
            )}

            {/* Login Button */}
            <button
              type="submit"
              disabled={isLoading}
              className="w-full bg-blue-600 text-white py-2 rounded-lg font-medium hover:bg-blue-700 transition-colors disabled:bg-blue-400 disabled:cursor-not-allowed mt-6"
            >
              {isLoading ? 'Logging in...' : 'Login'}
            </button>
          </form>

          {/* Footer */}
          <div className="mt-6 pt-6 border-t border-gray-200">
            <p className="text-xs text-center text-gray-500">
              This is a secure page. Only authorized users can access the dashboard.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
